import { useState, useEffect } from "react";
import { Modal, Button, Form, Input, Select, DatePicker, Spin } from "antd";
import { withRouter } from "react-router";
import {
  getAnnouncementById,
  updateAnnouncementById,
} from "@api/notification/announcement";
import { SuccessNotification, ErrorNotification } from "../..";
import moment from "moment";

const initialState = {
  title: "",
  content: "",
  location: "",
  active: "",
  start: "",
  end: "",
};

const AnnouncementUpdateModal = ({
  open,
  handleModalClick,
  fetchAnnouncements,
  announcementId,
}) => {
  const [values, setValues] = useState(initialState);
  const [dateRange, setDateRange] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchAnnouncementById();
  }, []);

  // Fetch announcement by id
  const fetchAnnouncementById = async () => {
    setLoading(true);
    try {
      const { data } = await getAnnouncementById(announcementId);

      // Change date format
      data.start = moment(data.start.split("T")[0], "YYYY/MM/DD");
      data.end = moment(data.end.split("T")[0], "YYYY/MM/DD");

      setValues(data);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log("GET_ANNOUNCEMENT_BY_ID_ERROR", err);
    }
  };

  // Handle form change
  const handleFormChange = (e) => {
    e.preventDefault();
    setValues({
      ...values,
      [e.target.name]: e.target.value,
    });
  };

  // Handle announcement update
  const handleAnnouncementUpdate = async (e) => {
    setLoading(true);
    e.preventDefault();

    // Set start and end date format
    if (dateRange.length > 0) {
      values.start = dateRange[0];
      values.end = dateRange[1];
    } else if (values.start && values.end) {
      values.start = moment(values.start).format("YYYY/MM/DD");
      values.end = moment(values.end).format("YYYY/MM/DD");
    }

    // Update announcement
    updateAnnouncementById(announcementId, values)
      .then(() => {
        setValues(initialState);
        handleModalClick();
        fetchAnnouncements();
        SuccessNotification("Announcement updated successfully");
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        ErrorNotification(err.response.data.message);
      });
  };

  return (
    <>
      <Modal
        title="Update Announcement"
        visible={open}
        onOk={handleModalClick}
        closable={false}
        width={600}
        footer={[
          <Button key="back" onClick={handleModalClick}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={handleAnnouncementUpdate}
            loading={loading}
          >
            Update
          </Button>,
        ]}
      >
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "calc(80vh - 50px)",
            }}
          >
            <Spin />
          </div>
        ) : (
          <Form
            labelCol={{
              span: 5,
            }}
            wrapperCol={{
              span: 16,
            }}
          >
            {/* Title */}
            <Form.Item label="Title">
              <Input
                name="title"
                placeholder="Enter announcement title"
                onChange={handleFormChange}
                value={values.title}
                rules={[{ required: true }]}
              />
            </Form.Item>

            {/* Announcement Content */}
            <Form.Item label="Content">
              <Input
                name="content"
                placeholder="Enter announcement content"
                onChange={handleFormChange}
                value={values.content}
                rules={[{ required: true }]}
              />
            </Form.Item>

            {/* Announcement Location */}
            <Form.Item label="Location">
              <Select
                name="location"
                placeholder="Select announcement location"
                onChange={(val) => setValues({ ...values, location: val })}
                value={values.location}
                rules={[{ required: true }]}
              >
                <Select.Option value="client">Client</Select.Option>
                <Select.Option value="landing-page">Landing Page</Select.Option>
                <Select.Option value="widget">Widget</Select.Option>
              </Select>
            </Form.Item>

            {/* Announcement Active */}
            <Form.Item label="Active">
              <Select
                name="active"
                placeholder="Select announcement active status"
                onChange={(val) => setValues({ ...values, active: val })}
                value={values.active}
                rules={[{ required: true }]}
              >
                <Select.Option value={true}>True</Select.Option>
                <Select.Option value={false}>False</Select.Option>
              </Select>
            </Form.Item>

            {/* Announcement Start Date Time */}
            {values?.start && (
              <Form.Item label="Start">
                <DatePicker.RangePicker
                  name="dateRange"
                  onChange={(date, dateString) => {
                    setDateRange(dateString);
                  }}
                  defaultValue={[values.start, values.end]}
                  autoFocus
                  popupStyle={{
                    height: "auto",
                  }}
                  getPopupContainer={(trigger) => trigger.parentNode}
                  style={{
                    width: "100%",
                  }}
                  popupAlign={{
                    offset: [0, 0],
                  }}
                />
              </Form.Item>
            )}
          </Form>
        )}
      </Modal>
    </>
  );
};

export default withRouter(AnnouncementUpdateModal);
